import React, { useState, useEffect } from 'react';
import Loader from '../../Search/Loader';

const CircuitRacesTable = ({ circuit, permalink }) => {
    const [loading, setLoading] = useState(true);
    const [circuitId, setCircuitId] = useState(circuit);
    const [circuitFilterId, setCircuitFilterId] = useState('');
    const [racesData, setRacesData] = useState([]);
    const [viewAll, setViewAll] = useState(false);
    const [viewPermalink, setViewPermalink] = useState(permalink);

    useEffect(() => {
        fetch(`${wp_ajax.db_ajax_url}?action=fetch_database_circuit_races&circuit_id=${circuitId}`)
            .then(res => res.json())
            .then(response => {
                setRacesData(response.data);
                setCircuitFilterId(response.filter);
                setLoading(false);

                if (response.data.length <= 3) {
                    setViewAll(true);
                }
            });
    }, []);

    if (loading) {
        return <Loader />;
    }

    const racesDataResults = () => {
        if (viewAll) {
            return racesData;
        }

        return racesData.slice(0, 3);
    };

    return (
        <div className="database-table-collapsible__table">
            <table className="database-table database-table--striped">
                <thead>
                    <tr className="proxima">
                        <th>Race name</th>
                        <th>Date</th>
                        <th>Championship</th>
                        <th>Laps</th>
                        <th>Winner</th>
                    </tr>
                </thead>
                <tbody>
                    {racesData.length > 0 &&
                        racesDataResults().map((race, i) => (
                            <tr key={i}>
                                <td>
                                    <p className="database-table__title">
                                        <a href={race.url}>{race.name}</a>
                                    </p>
                                </td>
                                <td>
                                    <p className="database-table__subtitle proxima">{race.race_date}</p>
                                </td>
                                <td>
                                    <p className="database-table__title">
                                        { race.championship_url !== '' ? (
                                            <a href={race.championship_url}>{race.championship_name}</a>
                                        ) : (
                                            <> {race.championship_name}</>                                          
                                        ) }
                                    </p>
                                </td>
                                <td>
                                    <p className="database-table__subtitle proxima">{race.laps}</p>
                                </td>
                                <td>
                                    {race.race_winner.length > 0 && race.race_winner.map((value, index) => {
                                        if (value.url !== '') {
                                            return <p className={value.css_class} key={index}><a href={value.url}>{value.name}</a></p>;
                                        } else {
                                            return <p className={value.css_class} key={index}>{value.name}</p>;
                                        }
                                    })}
                                </td>
                            </tr>
                        ))}
                    {racesData.length < 1 && (
                        <tr>
                            <td colSpan="5">No results available in the database</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {!viewAll && (
                <>
                    <br />
                    { viewPermalink ? (
                        <a href={viewPermalink} className="button button--outline">
                            View all results
                        </a>
                    ) : (
                        <a onClick={() => {
                            setViewAll(true);
                            setViewPermalink(`/database/races/?race_circuit=${circuitFilterId}`);
                        }} className="button button--outline">
                            View all results
                        </a>
                    ) }
                </>
            )}
            
            { viewPermalink && viewAll ? (
                <>
                    <br />
                    <a href={viewPermalink} className="button button--outline">
                        View more
                    </a>
                </>
            ): '' }

        </div>
    );
};

export default CircuitRacesTable;
